import { h } from 'preact';
import { createPortal, memo, useEffect, useState } from 'preact/compat';
import './styles.scss';

const noMove = e => e.cancelable && e.preventDefault();

const Modal = ({ isOpen, onMaskClick, children }) => {
  const [isStateOpen, setIsStateOpen] = useState(isOpen);

  useEffect(() => {
    setIsStateOpen(isOpen);
  }, [isOpen]);

  return isStateOpen
    ? createPortal(
        <div id="taker-assist">
          <div className="taker-assist mask animate-fade-in" onClick={onMaskClick} onTouchMove={noMove} />
          <div onTouchMove={noMove} className="taker-assist content_ta content-center_ta animate-center-show">
            {children}
          </div>
        </div>,
        document.body
      )
    : null;
};

export default memo(Modal);
